module.exports = __webpack_public_path__ + "static/img/new_year.e4e2d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/new_year.jpg
// module id = UJAs
// module chunks = 1